module.exports = __webpack_public_path__ + "static/38-85a0ff0dc52f68f32300982e1a9a16ae.png";